"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotherRoomTabs = MotherRoomTabs;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
function MotherRoomTabs(props) {
    var tab = props.tab, onTabChange = props.onTabChange;
    var ROOM_TABS = [
        { key: "mother-plants", label: "Mother Plants" },
        { key: "tasks", label: "Tasks" },
    ];
    return ((0, jsx_runtime_1.jsx)(react_1.Tabs, { selectedKey: tab, onSelectionChange: function (key) { return onTabChange(key); }, className: "w-fit", children: (0, jsx_runtime_1.jsx)(react_1.Tabs.ListContainer, { children: (0, jsx_runtime_1.jsx)(react_1.Tabs.List, { "aria-label": "Mother Room sections", children: ROOM_TABS.map(function (roomTab) { return ((0, jsx_runtime_1.jsxs)(react_1.Tabs.Tab, { id: roomTab.key, className: "whitespace-nowrap", children: [roomTab.label, (0, jsx_runtime_1.jsx)(react_1.Tabs.Indicator, {})] }, roomTab.key)); }) }) }) }));
}
